import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TipLink from './StyledTipLink'
import Icon from './StyledIcon'
import SmallTitle from './StyledSmallTitle'
import { TIP_OF_THE_DAY_ICONS } from '../../../constants'

class SmallTipBox extends Component {
  getIcon (tags) {
    let result = 'default.png'
    for (let tag of tags) {
      const value = Object.values(tag)[0]
      const icon = TIP_OF_THE_DAY_ICONS[value]
      if (icon) {
        result = icon
        break
      }
    }

    return `/images/tipoftheday/${result}`
  }

  render () {
    const {
      box: {
        link,
        smallTitle,
        tags
      }
    } = this.props

    return (
      <TipLink href={link}>
        <Icon src={this.getIcon(tags)}/>
        <div>
          <SmallTitle>
            { smallTitle }
          </SmallTitle>
        </div>
      </TipLink>
    )
  }
}

SmallTipBox.propTypes = {
  box: PropTypes.object.isRequired
}

export default SmallTipBox
